import React, { Fragment, useState } from "react";
import "./index.css";
import { Card, Row, Typography } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Controller } from "swiper";
import "swiper/swiper.less";
import "swiper/components/navigation/navigation.less";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { HomeSection } from "../../../../../domain";
import { Link } from "react-router-dom";

const ITEM_PER_VIEW_MOBILE = 2
const ITEM_PER_VIEW_COMPUTER = 6

SwiperCore.use([Navigation, Controller]);

type ScrollBarProps = { section: HomeSection };

const ScrollBar: React.FC<ScrollBarProps> = ({ section }) => {
  const { width } = useWindowDimensions();

  const [controlledSwiper, setControlledSwiper] = useState<
    SwiperCore | undefined
  >(undefined);

  const navigationPrevRef = React.useRef<HTMLElement>(null);
  const navigationNextRef = React.useRef<HTMLElement>(null);

  return (
    <Card
      style={{
        margin: 16,
        borderRadius: 10,
        boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
        backgroundColor: 'whitesmoke',
      }}
      bodyStyle={{ padding: 0 }}
    >
      <Typography.Title level={3} style={{ margin: 0, padding: "16px 16px 0 0px" }}>
        {section.title}
      </Typography.Title>
      <Typography.Paragraph style={{ margin: 0, padding: "0 16px 0 0px" }}>
        {section.description}
      </Typography.Paragraph>
      <div style={{ padding: 16 }}>
        <Swiper
          controller={{ control: controlledSwiper }}
          onSwiper={setControlledSwiper}
          slidesPerView={isMobile ? ITEM_PER_VIEW_MOBILE : ITEM_PER_VIEW_COMPUTER}
          spaceBetween={16}

          navigation={{
            nextEl: navigationNextRef.current
              ? navigationNextRef.current
              : undefined,
            prevEl: navigationPrevRef.current
              ? navigationPrevRef.current
              : undefined,
          }}

        >
          {section.items.map((item) => {
            const { product } = item;
            const attribute = product.getFirstAvailableAttribute();
            const { price, offPrice } = attribute;
            const hasOff = attribute.hasOff();
            const offPercent = Math.floor(((price - offPrice) / price) * 100);
            return (
              <SwiperSlide>
                <Link
                  to={`/product/${product.id}/${encodeURIComponent(
                    product.title
                  )}`}
                >
                  <Card

                    bodyStyle={{ margin: 0, padding: 0, boxShadow: "0px 0px 2px 2px rgba(208, 216, 243, 0.3)", borderRadius: 10 }}
                    style={{ padding: 0, margin: 0, borderRadius: 10 }}
                  >
                    <div style={{ position: "relative" }}>
                      <img
                        src={product.images[0]}
                        alt={product.title}
                        width="100%"
                        style={{ objectFit: "cover", borderRadius: "10px 10px 0px 0px" }}
                        height={
                          isMobile
                            ? (width - 96 - 8) / ITEM_PER_VIEW_MOBILE
                            : ((width <= 1366 ? width : 1366) - 144 - 14) / ITEM_PER_VIEW_COMPUTER
                        }
                      />
                      {hasOff ? (
                        <div className="product-card-off-badge">{`%${offPercent} تخفیف`}</div>
                      ) : (
                        <Fragment />
                      )}
                    </div>
                    <div className="scrollbar-item-title">
                      <Typography.Text>{product.title}</Typography.Text>
                    </div>
                    {hasOff ? (
                      <Row className="scrollbar-item-off-price" justify="center">
                        <Typography.Text>
                          {price.toLocaleString()} تومان
                        </Typography.Text>
                      </Row>
                    ) : (
                      <Fragment />
                    )}
                    <Row className="scrollbar-item-price" justify="center">
                      <Typography.Text>
                        {(hasOff ? offPrice : price).toLocaleString()} تومان
                      </Typography.Text>
                    </Row>
                  </Card>
                </Link>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <span
        className="scrollbar-prev-button"
        ref={navigationPrevRef}
        onClick={() => controlledSwiper?.slidePrev()}
      >
        <RightOutlined style={{ fontSize: 24 }} />
      </span>
      <span
        className="scrollbar-next-button"
        ref={navigationNextRef}
        onClick={() => controlledSwiper?.slideNext()}
      >
        <LeftOutlined style={{ fontSize: 24 }} />
      </span>
    </Card >
  );
};

export default ScrollBar;
